import { Button, CircularProgress, DialogActions, DialogContent, FormControl, FormHelperText, Grid, InputLabel, MenuItem, Select, Switch, TextField } from "@material-ui/core";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { withFirebase } from "../Firebase";
import { isValidDNI, isValidPhone } from "../RescuerSignUp/SignUpForm";
import { Autocomplete } from "@material-ui/lab";

function Name(props) {
    const { close, firebase, auth } = props;
    const { t } = useTranslation();

    const [name, setName] = useState(auth?.info?.name);
    const [surname, setSurname] = useState(auth?.info.surname);
    const [secondSurname, setSecondSurname] = useState(auth?.info?.secondSurname);
    const [isLoading, setisLoading] = useState(false);
    const [nameError, setNameError] = useState(false);
    const [surnameError, setSurnameError] = useState(false);

    const handleChange = () => {
        setisLoading(true);

        if (name.length > 1 && surname.length > 1) {
            firebase
                .user(auth.sgpfc.reportId)
                .child("info")
                .update({
                    name: name,
                    surname: surname,
                    secondSurname: !!secondSurname ? secondSurname : "",
                })
                .then(() => {
                    firebase
                        .currentUser()
                        .updateProfile({
                            displayName: name,
                        })
                        .then(() => {
                            setisLoading(false);
                            close();
                        });
                });
        } else {
            name.length < 1 && setNameError(true);
            surname.length < 1 && setSurnameError(true);
        }
    };

    useEffect(() => {
        setNameError(name == "");
    }, [name]);

    useEffect(() => {
        setSurnameError(surname == "");
    }, [surname]);

    return (
        <DialogContent>
            <Grid container justifyContent="center" spacing={3} style={{ marginTop: 12, marginBottom: 12 }}>
                <Grid item xs={12}>
                    <TextField
                        autoFocus
                        id="name"
                        type="text"
                        fullWidth
                        label={t("name")}
                        error={nameError}
                        helperText={nameError && t("notEmptyField")}
                        variant="outlined"
                        required
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                    />
                </Grid>
                <Grid item xs={12}>
                    <TextField
                        id="Surname1"
                        type="text"
                        error={surnameError}
                        helperText={surnameError && t("notEmptyField")}
                        fullWidth
                        label={t("ape1")}
                        variant="outlined"
                        required
                        value={surname}
                        onChange={(e) => setSurname(e.target.value)}
                    />
                </Grid>
                <Grid item xs={12}>
                    <TextField id="Surnam2" type="text" fullWidth label={t("ape2")} variant="outlined" value={secondSurname} onChange={(e) => setSecondSurname(e.target.value)} />
                </Grid>
            </Grid>
            <DialogActions>
                <Button onClick={close} color="primary">
                    {t("cancelar")}
                </Button>
                <Button variant="outlined" color="primary" disabled={isLoading || nameError || surnameError} onClick={handleChange}>
                    {isLoading && (
                        <CircularProgress
                            size={24}
                            style={{
                                position: "absolute",
                                top: "50%",
                                left: "50%",
                                marginTop: -12,
                                marginLeft: -12,
                            }}
                        />
                    )}
                    {t("save")}
                </Button>
            </DialogActions>
        </DialogContent>
    );
}

function BirthDay(props) {
    const { close, firebase, auth } = props;
    const { t } = useTranslation();

    const [error, setError] = useState(false);
    const [day, setDay] = useState("");
    const [month, setMonth] = useState("");
    const [year, setYear] = useState();
    const [yearError, setYearError] = useState(false);
    const [dayError, setDayError] = useState(false);

    const [isLoading, setisLoading] = useState(false);

    useEffect(() => {
        const birthDate = moment(auth?.info?.birthday, "DD/MM/YYYY");
        const isValid = birthDate.isValid();
        if (isValid) {
            setDay(birthDate.format("DD"));
            setMonth(birthDate.format("MMMM"));
            setYear(birthDate.year());
        }
    }, [auth]);

    const handleChange = () => {
        setisLoading(true);
        if (checkDate()) {
            firebase
                .user(auth.sgpfc.reportId)
                .child("info")
                .update({ birthday: moment(`${day}/${month}/${year}`, "DD/MMMM/YYYY").format("DD/MM/YYYY") })
                .then(() => {
                    setisLoading(false);
                    close();
                });
        }
    };

    const checkDate = () => {
        const date = moment(`${day}/${month}/${year}`, "DD/MMMM/YYYY");
        const momentValid = date.isValid();
        const isempty = day == "" || year == "";
        const yearsGap = 100;
        const validYear = year >= moment().year() - yearsGap;

        setError(!momentValid || isempty || date.isAfter() || !validYear);
        if (!momentValid) {
            const invalid = date.invalidAt();
            invalid == 0 ? setYearError(true) : setDayError(true);
        } else {
            setDayError(day == "");
            setYearError(year == "" || year < moment().year() - yearsGap);
        }
        return momentValid && !isempty && !date.isAfter() && validYear;
    };

    useEffect(() => {
        checkDate();
    }, [day, month, year]);

    const handleDayChange = (e) => {
        const value = e.target.value.replace(/\D/g, "");
        setDay(value);
    };

    const handleYearChange = (e) => {
        const value = e.target.value.replace(/\D/g, "");
        setYear(value);
    };

    return (
        <DialogContent>
            <Grid container justifyContent="center" spacing={3} style={{ marginTop: 12, marginBottom: 12 }}>
                <Grid container spacing={3} style={{ padding: 24 }}>
                    <Grid item xs={3}>
                        <TextField variant="outlined" label={t("day")} value={day} fullWidth onChange={handleDayChange} error={dayError}></TextField>
                    </Grid>
                    <Grid item xs={5}>
                        <FormControl fullWidth variant="outlined">
                            <InputLabel id="demo-simple-select-label">{t("month")}</InputLabel>
                            <Select labelId="demo-simple-select-label" id="demo-simple-select" label={t("month")} value={month} onChange={(e) => setMonth(e.target.value)}>
                                {moment.months().map((m) => (
                                    <MenuItem value={m}>{m}</MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid item xs={4}>
                        <TextField variant="outlined" label={t("year")} value={year} fullWidth onChange={handleYearChange} error={yearError}></TextField>
                    </Grid>
                    <FormHelperText style={{ paddingLeft: 18, marginTop: -8 }} error={error}>
                        {error
                            ? moment(`${day}/${month}/${year}`, "DD/MMMM/YYYY").isAfter()
                                ? t("La_fecha_de_cumpleaños_no_puede_ser_posterior_a_hoy")
                                : t("Introduce_una_fecha_válida")
                            : ""}
                    </FormHelperText>
                    <Grid item xs={12}>
                        {/*}  <MuiPickersUtilsProvider utils={MomentUtils}>
            <KeyboardDatePicker
              autoOk
              autoFocus
              fullWidth
              variant="inline"
              inputVariant="outlined"
              label={t("birthDay")}
              format="DD/MM/YYYY"
              placeholder={t("DD/MM/YYYY")}
              value={date}
              required
              maxDate={new Date()}
              maxDateMessage={t("maxDateMessage")}
              minDateMessage={t("minDateMessage")}
              invalidDateMessage={t("invalidDateMessage")}
              InputAdornmentProps={{ position: "none" }}
              onChange={(date) => {
                setDate(date);
                setError(!checkDate(date));
              }}
              onBlur={(date) => checkDate(date)}
              onError={(err) => setError(err != "")}
            />
            </MuiPickersUtilsProvider>}*/}
                    </Grid>
                </Grid>
            </Grid>
            <DialogActions>
                <Button onClick={close} color="primary">
                    {t("cancelar")}
                </Button>
                <Button variant="outlined" color="primary" disabled={isLoading || error} onClick={handleChange}>
                    {isLoading && (
                        <CircularProgress
                            size={24}
                            style={{
                                position: "absolute",
                                top: "50%",
                                left: "50%",
                                marginTop: -12,
                                marginLeft: -12,
                            }}
                        />
                    )}
                    {t("save")}
                </Button>
            </DialogActions>
        </DialogContent>
    );
}

function DNI(props) {
    const { close, firebase, auth } = props;
    const { t } = useTranslation();

    const [dni, setdni] = useState(auth?.info?.dni);
    const [error, setError] = useState(false);
    const [isLoading, setisLoading] = useState(false);

    const handleChange = () => {
        setisLoading(true);

        if (isValidDNI(dni)) {
            firebase
                .user(auth.sgpfc.reportId)
                .child("info")
                .update({
                    dni: dni,
                })
                .then(() => {
                    setisLoading(false);
                    close();
                });
        } else {
            setError(true);
        }
    };

    useEffect(() => {
        setError(!isValidDNI(dni));
    }, [dni]);

    return (
        <DialogContent>
            <Grid container justifyContent="center" spacing={3} style={{ marginTop: 12, marginBottom: 12 }}>
                <Grid item xs={12}>
                    <TextField
                        id="DNI"
                        variant="outlined"
                        name="DNI"
                        value={dni}
                        helperText={error && t("dnibadFormat")}
                        error={error}
                        onBlur={(e) => setError(!isValidDNI(e.target.value))}
                        onChange={(e) => setdni(e.target.value.toUpperCase())}
                        type="text"
                        required
                        label={t("dni")}
                        fullWidth
                        inputProps={{ maxLength: 9 }}
                    />
                </Grid>
            </Grid>
            <DialogActions>
                <Button onClick={close} color="primary">
                    {t("cancelar")}
                </Button>
                <Button variant="outlined" color="primary" disabled={isLoading || error} onClick={handleChange}>
                    {isLoading && (
                        <CircularProgress
                            size={24}
                            style={{
                                position: "absolute",
                                top: "50%",
                                left: "50%",
                                marginTop: -12,
                                marginLeft: -12,
                            }}
                        />
                    )}
                    {t("save")}
                </Button>
            </DialogActions>
        </DialogContent>
    );
}

function PhoneNumber(props) {
    const { close, firebase, auth } = props;
    const { t } = useTranslation();

    const [phoneNumber, setPhoneNumber] = useState(auth?.info?.phone);
    const [error, setError] = useState(false);
    const [isLoading, setisLoading] = useState(false);

    const handleChange = () => {
        setisLoading(true);

        if (isValidPhone(phoneNumber)) {
            firebase
                .user(auth.sgpfc.reportId)
                .child("info")
                .update({
                    phone: phoneNumber,
                })
                .then(() => {
                    setisLoading(false);
                    close();
                });
        } else {
            setError(true);
        }
    };

    useEffect(() => {
        setError(!isValidPhone(phoneNumber));
    }, [phoneNumber]);

    return (
        <DialogContent>
            <Grid container justifyContent="center" spacing={3} style={{ marginTop: 12, marginBottom: 12 }}>
                <Grid item xs={12}>
                    <TextField
                        id="phone"
                        variant="outlined"
                        name="Telefono"
                        value={phoneNumber}
                        helperText={error && t("invalidFormt")}
                        error={error}
                        onBlur={(e) => setError(!isValidPhone(e.target.value))}
                        onChange={(e) => setPhoneNumber(e.target.value)}
                        type="tel"
                        required
                        label={t("phoneNumber")}
                        fullWidth
                    />
                </Grid>
            </Grid>
            <DialogActions>
                <Button onClick={close} color="primary">
                    {t("cancelar")}
                </Button>
                <Button variant="outlined" color="primary" disabled={isLoading || error} onClick={handleChange}>
                    {isLoading && (
                        <CircularProgress
                            size={24}
                            style={{
                                position: "absolute",
                                top: "50%",
                                left: "50%",
                                marginTop: -12,
                                marginLeft: -12,
                            }}
                        />
                    )}
                    {t("save")}
                </Button>
            </DialogActions>
        </DialogContent>
    );
}

function Langs(props) {
    const { close, firebase, auth, settings, param } = props;
    const { t, i18n } = useTranslation();

    const [lang, setLang] = useState();
    const [error, setError] = useState(false);
    const [isLoading, setisLoading] = useState(false);

    const items = [
        { title: t("spanish"), op: "es" },
        { title: t("lang.eu"), op: "eu" },
        { title: t("lang.en"), op: "en" },
    ];

    useEffect(() => {
        setError(!!!lang);
    }, [lang]);

    const handleChange = () => {
        setisLoading(true);
        if (param === "defaultLang" && auth.sgpfc.reportId === firebase.currentUser.uid) {
            i18n.changeLanguage(lang.op);
        }
        firebase
            .user(auth.sgpfc.reportId)
            .child(settings)
            .update({
                [param]: lang.op,
            })
            .then(() => {
                setisLoading(false);
                close();
            })
            .catch(() => setisLoading(false));
    };

    return (
        <DialogContent>
            <Grid container justifyContent="center" spacing={3} style={{ marginTop: 12, marginBottom: 12 }}>
                <Grid item xs={12}>
                    <Autocomplete
                        id="combo-box-demo"
                        value={lang}
                        onChange={(event, newLang) => {
                            setLang(newLang);
                        }}
                        options={items}
                        getOptionLabel={(op) => op.title}
                        renderInput={(params) => <TextField {...params} value={lang?.op} label={t("languaje")} variant="filled" fullWidth />}
                    />
                </Grid>
            </Grid>
            <DialogActions>
                <Button onClick={close} color="primary">
                    {t("cancelar")}
                </Button>
                <Button variant="outlined" color="primary" disabled={error} onClick={handleChange}>
                    {isLoading && (
                        <CircularProgress
                            size={24}
                            style={{
                                position: "absolute",
                                top: "50%",
                                left: "50%",
                                marginTop: -12,
                                marginLeft: -12,
                            }}
                        />
                    )}
                    {t("save")}
                </Button>
            </DialogActions>
        </DialogContent>
    );
}
function EnableComunications(props) {
    const { close, firebase, auth } = props;
    const { t } = useTranslation();

    const [enabled, setEnabled] = useState(false);

    useEffect(() => {
        if (!!auth?.info?.comunicaciones) {
            setEnabled(auth?.info?.comunicaciones);
        }
    }, [auth]);

    const handleChange = (e) => {
        setEnabled(!enabled);
        firebase.user(auth.sgpfc.reportId).child("info").update({
            comunicaciones: !enabled,
        });
    };

    return <Switch checked={enabled} onChange={handleChange} name="comunication" />;
}

export const NameEdit = withFirebase(Name);
export const BirthDayEdit = withFirebase(BirthDay);
export const DNIEdit = withFirebase(DNI);
export const PhoneNumberEdit = withFirebase(PhoneNumber);
export const LangsEdit = withFirebase(Langs);
export const EnableComunicationsEdit = withFirebase(EnableComunications);
